if($('.in-index').length){
    if($('.welcome-wrapper p img[style="float: right;"]').length){
        $('.welcome-wrapper .container>.welcome-wrapper').append($('.welcome-wrapper img[style="float: right;"]').closest('p'))
    }
}